export const selectPipelineValueByCustomerData = (state) =>
  state.capture.pipelineValueByCustomer.data;

export const selectPipelineValueByCustomerLoading = (state) =>
  state.capture.pipelineValueByCustomer.isLoading;

export const selectPipelineValueByCustomerError = (state) =>
  state.capture.pipelineValueByCustomer.error;
